import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {TaskModel} from "../../models/task.model";

@Injectable({providedIn: 'root'})
export class TasksHttpService {

  private base_url = `/tasks`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getTasks(taskIds: string[]): Observable<TaskModel[]> {
    return this.http
      .post<TaskModel[]>(`${this.base_url}/byId`, {ids: taskIds});
  }

}
